import { render, staticRenderFns } from "./StatBranchPage.vue?vue&type=template&id=0ffc7c78&scoped=true"
import script from "./StatBranchPage.vue?vue&type=script&lang=js"
export * from "./StatBranchPage.vue?vue&type=script&lang=js"
import style0 from "./StatBranchPage.vue?vue&type=style&index=0&id=0ffc7c78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffc7c78",
  null
  
)

export default component.exports